export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20modern%20home%20entertainment%20scene%20with%20a%20large%20television%20screen%20displaying%20vibrant%20drama%20content%2C%20warm%20ambient%20lighting%20with%20golden%20and%20crimson%20tones%2C%20comfortable%20viewing%20atmosphere%2C%20cinematic%20color%20grading%2C%20abstract%20geometric%20elements%20suggesting%20streaming%20and%20connectivity%2C%20rich%20depth%20of%20field%2C%20editorial%20composition%20with%20dramatic%20shadows%2C%20clean%20modern%20aesthetic%20with%20warm%20color%20palette&width=1600&height=900&seq=hero-bg-laozi-2026&orientation=landscape"
          alt="老子影视网 - 电视剧大全全集播放平台主视觉"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium tracking-wide bg-accent-500/90 text-white mb-4 whitespace-nowrap">
              每日更新 · 高清不缓冲
            </span>
            <h1 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-4">
              老子影视网
              <span className="block text-2xl md:text-3xl lg:text-4xl font-medium text-white/85 mt-2">
                电视剧大全全集播放平台
              </span>
            </h1>
            <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-5">
              国产剧全集、韩剧全集、最新电视剧一网打尽。老子影视网为您提供免费在线观看服务，
              高清画质流畅不缓冲，每日同步更新热门剧集。无论您是追国产热剧还是韩剧经典，
              这里都能满足您的追剧需求，是您贴心的掌上追剧伴侣。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-7">
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>覆盖国产剧、韩剧等 20+ 品类</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>每日实时同步更新热播剧集</span>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>高清画质 · 流畅不缓冲播放</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 border border-white/30 hover:border-white/60 text-white font-medium rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-movie-2-line text-lg"></i>
                浏览精选剧集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[360px] md:h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20poster%20composition%20featuring%20dramatic%20warm%20lighting%20with%20crimson%20and%20gold%20tones%2C%20abstract%20film%20reel%20and%20streaming%20elements%2C%20modern%20entertainment%20aesthetic%2C%20glowing%20accents%2C%20rich%20dark%20background%20with%20dramatic%20highlights%2C%20premium%20editorial%20style%2C%20clean%20composition%20with%20atmospheric%20depth&width=720&height=960&seq=hero-visual-laozi-2026&orientation=portrait"
                alt="老子影视网平台主视觉 - 高清电视剧在线播放"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}